module.exports = __webpack_public_path__ + "img/neumocabeza.8507a01c.png";